import axios from 'axios'

// Blob downloads return their JSON error body as a Blob, so it's parsed before reading the message.
export async function emailDownloadError(error: unknown): Promise<string> {
	if (axios.isAxiosError(error)) {
		let data: unknown = error.response?.data
		if (data instanceof Blob) {
			try {
				data = JSON.parse(await data.text())
			} catch {
				return 'The download failed. Please try again.'
			}
		}
		if (data && typeof data === 'object' && 'message' in data && typeof data.message === 'string') {
			return data.message
		}
	}
	return 'The request failed. Please try again.'
}
